/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ picked: NonNullable<unknown>, total: NonNullable<unknown> }} Admin_Export_Customers_CountInputs */



/**
* | output |
* | --- |
* | "{picked} of {total} selected" |
*
* @param {Admin_Export_Customers_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_customers_count = /** @type {((inputs: Admin_Export_Customers_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Customers_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.picked} von ${i?.total} ausgewählt`)
	return /** @type {LocalizedString} */ (`${i?.picked} of ${i?.total} selected`)
});